// extracted by mini-css-extract-plugin
export var orderSummary = "_u7-0";
export var showMoreLessButton = "_u7-1";